import api from './index'

const resource = 'statistics'

export default {
  getBasicInfo () {
    return api.get(`${resource}/basic_info`)
  }
}
